/* DARMA set page as a product page (R3, Oct 2 2026; direction A "PDP twin").
   Companion to sections/darma-set-page.liquid, snippets/darma-setpdp-panel.liquid
   and snippets/darma-setpdp-library.liquid.

   The curtain in the section resolves ?set= before paint and, once parsed, keeps
   only the shown panel (it hands every panel to window.__dsp.panels first and
   fires 'dsp:ready'). This file then composes, for the shown set only:
   - the three collapsible rows (PRODUCT DETAILS and CARE INSTRUCTIONS broken out
     by item, SHIPPING AND RETURNS once), from the product library;
   - A CLOSER LOOK by Derek's rule: a set with a jewelry item = the jewelry's
     Precious Metals + the accessories' Handcrafted Quality and Lifetime Warranty;
     accessories only = the accessories' three; jewelry with cologne = the
     jewelry's three; cologne alone = the cologne's three. Cologne never supplies a
     column next to another item;
   - CUSTOMER REVIEWS combined across the items (score = rating x count summed over
     the summed count), ONE review per item by default, "Show more reviews" for
     the rest Judge.me published, each review tagged with its item;
   - MORE SETS: the current set card, picked from the other panels (same family
     first, then sets sharing an item), built from the numbers those panels'
     Liquid already computed (no money math here);
   - the ItemList structured data (the items keep their own Product ratings);
   - the phone gallery counter and dots;
   - 750 up, the full-screen photo viewer (Oct 10 2026).
   The ADD is assets/darma-set-card.js, untouched. */
(function () {
  'use strict';
  if (window.__dsppInit) return;
  window.__dsppInit = true;

  var $ = function (sel, root) { return (root || document).querySelector(sel); };
  var $$ = function (sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); };
  var esc = function (s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  };
  /* visible text of a node, without its visually-hidden helpers */
  var txt = function (el) {
    if (!el) return '';
    var c = el.cloneNode(true);
    $$('.visually-hidden', c).forEach(function (n) { n.parentNode.removeChild(n); });
    return c.textContent.replace(/\s+/g, ' ').trim();
  };

  function itemsOf(panel) {
    return $$('.dspp__row', panel).map(function (r) {
      var nm = $('.dspp__nm', r);
      var dot = $('.dspp__dot', r);
      return {
        row: r,
        h: r.getAttribute('data-h'),
        c: r.getAttribute('data-c'),
        k: r.getAttribute('data-k'),
        u: r.getAttribute('data-u'),
        t: nm ? nm.textContent.trim() : '',
        img: $('.dspp__thumb img', r),
        mat: txt($('.dspp__mat', r)),
        hasVar: !!$('.dspp__var', r),
        hex: dot ? dot.style.background : '',
        soldout: !!$('.dspp__soldout', r),
        was: txt($('.dspp__was', r)),
        share: txt($('.dspp__share', r))
      };
    });
  }

  function lib() { return $('[data-dspl]'); }
  function tplOf(h) {
    var L = lib();
    return L ? L.querySelector('template[data-dspl-p="' + h + '"]') : null;
  }
  function part(h, f) {
    var t = tplOf(h);
    var n = t ? t.content.querySelector('[data-f="' + f + '"]') : null;
    var ref = n && n.getAttribute('data-ref');
    if (ref) {
      /* a column shared word for word with an earlier product: rendered once */
      n = null;
      $$('template[data-dspl-p]', lib()).some(function (x) {
        n = x.content.querySelector('[data-id="' + ref + '"]');
        return !!n;
      });
    }
    return n;
  }
  function uniq(items) {
    var seen = {}, out = [];
    items.forEach(function (it) { if (!seen[it.h]) { seen[it.h] = 1; out.push(it); } });
    return out;
  }

  /* ---- the hero frames: one per item, drawn from the row's own packshot (the
     variant's on-white featured image), never past the file's width ---- */
  function frames(panel, items) {
    var figs = $$('.dspp__f--item', panel);
    figs.forEach(function (fig, i) {
      var di = parseInt(fig.getAttribute('data-i'), 10), it = items[isNaN(di) ? i : di], th = it && it.img;
      if (!th || $('img', fig)) return;
      var base = (th.getAttribute('src') || '').replace(/([?&])width=\d+/, '$1width=');
      var nat = parseInt(th.getAttribute('width'), 10) || 1600;
      var ws = [400, 800, 1200, 1600].filter(function (w) { return w <= nat; });
      if (!ws.length || ws[ws.length - 1] < nat) ws.push(nat); /* the file's own width last */
      var im = document.createElement('img');
      im.className = 'dspp__img';
      im.alt = fig.getAttribute('data-alt') || it.t;
      im.loading = 'lazy';
      im.width = nat;
      im.height = parseInt(th.getAttribute('height'), 10) || nat;
      im.sizes = '(min-width: 750px) 27vw, 100vw';
      im.srcset = ws.map(function (w) { return base + w + ' ' + w + 'w'; }).join(', ');
      im.src = base + (ws.indexOf(800) > -1 ? 800 : ws[ws.length - 1]);
      fig.insertBefore(im, fig.firstChild);
    });
  }

  /* ---- the three collapsible rows ---- */
  function fillRows(panel, items) {
    var accs = $('[data-dspp-accs]');
    var info = $('.dspp__info', panel);
    if (accs && info) { info.appendChild(accs); accs.hidden = false; }
    ['details', 'care'].forEach(function (f) {
      var box = $('[data-dspp-fill="' + f + '"]');
      if (!box) return;
      var html = '';
      uniq(items).forEach(function (it) {
        var p = part(it.h, f);
        if (!p || !p.textContent.trim()) return;
        html += '<p class="dspp-acc__sub">' + esc(it.t) + '</p>' + p.innerHTML;
      });
      box.innerHTML = html;
      if (!html) box.closest('.dspp-acc').hidden = true;
    });
    var ship = $('[data-dspp-fill="ship"]');
    var st = lib() && lib().querySelector('template[data-dspl-ship]');
    if (ship) {
      if (st) ship.innerHTML = st.innerHTML;
      else ship.closest('.dspp-acc').hidden = true;
    }
  }

  /* ---- A CLOSER LOOK ---- */
  function fillCloser(items) {
    var sec = $('[data-dspc]'), grid = $('[data-dspc-grid]');
    if (!sec || !grid) return;
    var u = uniq(items);
    var find = function (pred) { for (var i = 0; i < u.length; i++) if (pred(u[i])) return u[i]; return null; };
    var jew = find(function (i) { return i.k === 'jewelry'; });
    var acc = find(function (i) { return i.k === 'belt' || i.k === 'hat' || i.k === 'wallet'; });
    var plan;
    if (jew && acc) plan = [[jew, 1], [acc, 2], [acc, 3]];
    else if (acc) plan = [[acc, 1], [acc, 2], [acc, 3]];
    else if (jew) plan = [[jew, 1], [jew, 2], [jew, 3]];
    else if (u[0]) plan = [[u[0], 1], [u[0], 2], [u[0], 3]];
    else plan = [];
    grid.innerHTML = '';
    plan.forEach(function (pc) {
      var n = part(pc[0].h, 'col' + pc[1]);
      if (n) grid.appendChild(document.importNode(n, true));
    });
    if (!grid.children.length) sec.hidden = true;
  }

  /* ---- CUSTOMER REVIEWS ---- */
  function fillReviews(items) {
    var sec = $('[data-dspr]');
    if (!sec) return;
    var sum = $('[data-dspr-sum]', sec), tabs = $('[data-dspr-tabs]', sec),
        list = $('[data-dspr-list]', sec), foot = $('[data-dspr-foot]', sec);
    var u = uniq(items);
    var tot = 0, wsum = 0, hist = { 5: 0, 4: 0, 3: 0, 2: 0, 1: 0 };
    var per = u.map(function (it) {
      var t = tplOf(it.h);
      var n = t ? parseInt(t.getAttribute('data-n'), 10) || 0 : 0;
      var r = t ? parseFloat(t.getAttribute('data-r')) || 0 : 0;
      tot += n; wsum += r * n;
      (t ? (t.getAttribute('data-hist') || '') : '').split(',').forEach(function (p) {
        var kv = p.split(':');
        if (kv.length === 2 && hist[kv[0]] != null) hist[kv[0]] += parseInt(kv[1], 10) || 0;
      });
      var revs = t ? $$('[data-f="rev"]', t.content) : [];
      return { it: it, n: n, r: r, revs: revs };
    });
    if (!tot) { sec.hidden = true; return; }
    var avg = Math.round((wsum / tot) * 10) / 10;
    var word = u.length >= 3 ? 'set' : 'set';
    var hmax = 0; for (var s in hist) hmax = Math.max(hmax, hist[s]);
    var htot = hist[5] + hist[4] + hist[3] + hist[2] + hist[1];

    var h = '<div><div class="dspr__score"><span class="dspr__big">' + avg.toFixed(1) + '</span><span>' +
      '<span class="dspp-stars" style="--r: ' + (avg * 20) + '%;" role="img" aria-label="' + avg.toFixed(1) + ' out of 5 stars"></span>' +
      '<span class="dspr__based">' + tot + (tot === 1 ? ' review' : ' reviews') + ' across the ' + word + '</span></span></div>' +
      '<ul class="dspr__items" role="list">';
    per.forEach(function (p) {
      h += '<li><b>' + esc(p.it.t) + '</b>' + (p.n ? p.r.toFixed(1) + ' (' + p.n + ')' : 'No reviews yet') + '</li>';
    });
    h += '</ul></div>';
    if (htot) {
      h += '<ul class="dspr__hist" role="list">';
      [5, 4, 3, 2, 1].forEach(function (st) {
        var w = hmax ? Math.round(hist[st] / hmax * 100) : 0;
        h += '<li><span>' + st + (st === 1 ? ' star' : ' stars') + '</span><span class="dspr__bar"><i style="width: ' + w + '%"></i></span><span>' + hist[st] + '</span></li>';
      });
      h += '</ul>';
    }
    sum.innerHTML = h;

    /* the review list: every review Judge.me published for each item, tagged */
    var all = [];
    per.forEach(function (p, pi) {
      var mine = p.revs.map(function (n) {
        var el = document.importNode(n, true);
        el.setAttribute('data-i', pi);
        var tag = $('[data-dspr-item]', el);
        if (tag) {
          if (p.it.img) {
            var im = document.createElement('img');
            im.src = p.it.img.getAttribute('src');
            im.alt = '';
            im.loading = 'lazy';
            im.width = 28; im.height = 28;
            tag.appendChild(im);
          }
          tag.appendChild(document.createTextNode(p.it.t));
        }
        return { el: el, ts: parseInt(n.getAttribute('data-ts'), 10) || 0, pi: pi };
      });
      mine.sort(function (a, b) { return b.ts - a.ts; });
      mine.forEach(function (m, k) { m.first = k === 0; all.push(m); });
    });
    all.sort(function (a, b) { return (b.first - a.first) || (b.ts - a.ts); });
    list.innerHTML = '';
    all.forEach(function (m) { list.appendChild(m.el); });

    var state = { tab: -1, more: false };
    var render = function () {
      var hidden = 0;
      all.forEach(function (m) {
        var show = state.tab === -1 ? (m.first || state.more) : m.pi === state.tab;
        m.el.hidden = !show;
        if (!show && state.tab === -1) hidden++;
      });
      var f = '';
      if (state.tab === -1 && hidden) {
        f += '<button type="button" class="dspr__more" data-dspr-more>Show more reviews</button>';
      }
      per.forEach(function (p, pi) {
        if ((state.tab === -1 && (state.more || !hidden)) || state.tab === pi) {
          if (p.n > p.revs.length && (state.tab === -1 || state.tab === pi)) {
            f += '<a class="dspr__more" href="' + esc(p.it.u) + '#judgeme_product_reviews">Read all ' + p.n + ' reviews of the ' + esc(p.it.t) + '</a>';
          }
        }
      });
      foot.innerHTML = f;
      $$('.dspr__tab', tabs).forEach(function (b) {
        b.setAttribute('aria-pressed', String(parseInt(b.getAttribute('data-i'), 10) === state.tab));
      });
    };
    if (!all.length) {
      list.innerHTML = '';
      tabs.innerHTML = '';
    } else {
      var tb = '<button type="button" class="dspr__tab" data-i="-1" aria-pressed="true">All ' + tot + '</button>';
      per.forEach(function (p, pi) {
        if (p.revs.length) tb += '<button type="button" class="dspr__tab" data-i="' + pi + '" aria-pressed="false">' + esc(p.it.t) + ' ' + p.n + '</button>';
      });
      tabs.innerHTML = tb;
      tabs.addEventListener('click', function (e) {
        var b = e.target.closest('.dspr__tab');
        if (!b) return;
        state.tab = parseInt(b.getAttribute('data-i'), 10);
        state.more = false;
        render();
      });
    }
    foot.addEventListener('click', function (e) {
      if (!e.target.closest('[data-dspr-more]')) return;
      state.more = true;
      render();
      var firstNew = all.filter(function (m) { return !m.first; })[0];
      if (firstNew && firstNew.el.focus) { firstNew.el.setAttribute('tabindex', '-1'); firstNew.el.focus({ preventScroll: true }); }
    });
    render();
  }

  /* ---- MORE SETS ---- */
  function family(name) { return String(name || '').replace(/\s+in\s+.+$/i, '').trim(); }
  var ARROW = '<svg class="dso__arrow" xmlns="http://www.w3.org/2000/svg" width="14" height="8" viewBox="0 0 14 8" fill="none" aria-hidden="true" focusable="false"><path d="M0 4h12.5M9.5 0.75L12.75 4 9.5 7.25" stroke="currentColor" stroke-width="1.1"/></svg>';
  function cardHTML(key, buy, items) {
    var name = buy.getAttribute('data-name');
    var P = buy.closest('[data-dsp-key]') || buy.parentNode;
    var tot = txt($('.dspp__now', P)), sub = txt($('.dspp__strike', P)), save = txt($('.dspp__save', P));
    var aria = name + (sub ? ', was ' + sub : '') + ', now ' + tot + (save ? ', ' + save.toLowerCase() : '');
    var h = '<a class="dso dso--card" href="/pages/set?set=' + encodeURIComponent(key) + '" aria-label="' + esc(aria) + '" title="' + esc(name) +
      '" data-set-key="' + esc(key) + '" data-ds-comp="' + esc(buy.getAttribute('data-ds-comp')) + '">' +
      '<div class="dso__head"><span class="dso__setname">' + esc(name) + '</span></div><div class="dso__items">';
    items.forEach(function (it) {
      var im = it.img;
      h += '<div class="dso__item"><div class="dso__tile">';
      if (im) {
        h += '<img src="' + esc(im.getAttribute('src')) + '" srcset="' + esc(im.getAttribute('srcset') || '') +
          '" sizes="(min-width: 750px) 120px, 104px" alt="" loading="lazy" width="' + esc(im.getAttribute('width')) + '" height="' + esc(im.getAttribute('height')) + '">';
      }
      h += '</div><div class="dso__info"><span class="dso__nm">' + esc(it.t) + '</span>';
      if (it.hasVar) h += '<span class="dso__var"><i class="dso__dot" style="background: ' + esc(it.hex) + ';" aria-hidden="true"></i>' + esc(it.c) + '</span>';
      else if (it.mat) h += '<span class="dso__mat">' + esc(it.mat) + '</span>';
      if (it.soldout) h += '<span class="dso__soldout">Sold out</span>';
      h += '</div><div class="dso__iprice">' + (it.was ? '<s class="dso__was">' + esc(it.was) + '</s>' : '') + '<span class="dso__now">' + esc(it.share) + '</span></div></div>';
    });
    h += '</div><div class="dso__tot"><span class="dso__shop">Shop the set' + ARROW + '</span><div class="dso__sum">' +
      (sub ? '<s class="dso__was">' + esc(sub) + '</s>' : '') + '<span class="dso__price">' + esc(tot) + '</span>' +
      (save ? '<span class="dso__save">' + esc(save) + '</span>' : '') + '</div></div></a>';
    return h;
  }
  function fillMore(G, shownKey, items) {
    var sec = $('[data-dspm]'), rail = $('[data-dspm-rail]');
    if (!sec || !rail) return;
    var panels = (G && G.panels) || $$('[data-dsp-key]');
    var me = $('.dspp__buy', document.querySelector('[data-dsp-key="' + shownKey + '"]'));
    var fam = family(me && me.getAttribute('data-name'));
    var cands = [];
    panels.forEach(function (P, order) {
      var k = P.getAttribute('data-dsp-key');
      if (!k || k === shownKey || k === '__none__') return;
      var b = $('.dspp__buy', P);
      if (!b) return;
      var its = itemsOf(P);
      var score = 0;
      its.forEach(function (o) {
        items.forEach(function (m) {
          if (o.h === m.h) score += (o.c === m.c ? 2 : 1);
        });
      });
      cands.push({ k: k, P: P, b: b, its: its, fam: family(b.getAttribute('data-name')) === fam, score: score, order: order });
    });
    var picks = cands.filter(function (c) { return c.fam; }).slice(0, 2);
    var rest = cands.filter(function (c) { return !c.fam && c.score > 0; })
      .sort(function (a, b) { return (b.score - a.score) || (a.order - b.order); });
    picks = picks.concat(rest).slice(0, 4);
    if (!picks.length) { sec.hidden = true; return; }
    rail.innerHTML = picks.map(function (c) {
      return '<li class="dspm__slide">' + cardHTML(c.k, c.b, c.its) + '</li>';
    }).join('');
  }

  /* ---- structured data: the set as a list of its item products ---- */
  function ld(name, items) {
    var o = location.origin;
    var data = {
      '@context': 'https://schema.org',
      '@type': 'ItemList',
      name: name,
      numberOfItems: items.length,
      itemListElement: items.map(function (it, i) {
        return { '@type': 'ListItem', position: i + 1, name: it.t, url: o + it.u };
      })
    };
    var s = document.createElement('script');
    s.type = 'application/ld+json';
    s.setAttribute('data-dspp-ld', '');
    s.textContent = JSON.stringify(data);
    document.head.appendChild(s);
  }

  /* ---- phone gallery: counter and dots follow the swipe ---- */
  function gallery(panel) {
    var gal = $('[data-dspp-gal]', panel);
    if (!gal) return;
    var cnt = $('[data-dspp-i]', panel), dots = $$('.dspp__dots i', panel);
    var last = 0, raf = 0;
    gal.addEventListener('scroll', function () {
      if (raf) return;
      raf = requestAnimationFrame(function () {
        raf = 0;
        var w = gal.clientWidth || 1;
        var i = Math.round(gal.scrollLeft / w);
        if (i === last) return;
        last = i;
        if (cnt) cnt.textContent = String(i + 1);
        dots.forEach(function (d, k) { d.classList.toggle('is-on', k === i); });
      });
    }, { passive: true });
  }

  /* ---- 750 up: click a photo for the full-screen viewer (Oct 10 2026, Derek).
     Reuses the product page's viewer markup and styles (.dpg-lb). Only the
     photos shown at this width are in it, so the composed lead never is. ---- */
  function viewer(panel) {
    var gal = $('[data-dspp-gal]', panel);
    if (!gal) return;
    var DESK = window.matchMedia('(min-width: 750px)');
    var name = (($('.dspp__h1', panel) || {}).textContent || '').trim();
    var lb = null, track, rail, prevB, nextB, list = [], cur = 0, lastFocus = null, prevOv = '';
    var esc = function (t) { return String(t).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); };
    function shown() { return $$('.dspp__f', gal).filter(function (f) { return f.offsetParent !== null && $('img', f); }); }
    function largest(im) {
      var best = im.getAttribute('src'), bw = 0;
      (im.getAttribute('srcset') || '').split(',').forEach(function (p) {
        var m = p.trim().split(/\s+/), w = parseInt(m[1], 10);
        if (m[0] && w > bw) { bw = w; best = m[0]; }
      });
      return best;
    }
    function mark() {
      var figs = shown();
      figs.forEach(function (f, i) {
        f.setAttribute('data-dspp-zoom', '');
        f.setAttribute('tabindex', '0');
        f.setAttribute('role', 'button');
        f.setAttribute('aria-label', 'Open image ' + (i + 1) + ' full screen');
      });
      if (figs[0] && !$('.dpg__tag', gal)) {
        var t = document.createElement('span');
        t.className = 'dpg__tag dpg__tag--click';
        t.setAttribute('aria-hidden', 'true');
        t.textContent = 'Click to expand';
        figs[0].appendChild(t);
      }
    }
    function build() {
      list = shown().map(function (f) { var im = $('img', f); return { src: largest(im), th: im.getAttribute('src'), alt: im.getAttribute('alt') || name }; });
      if (!lb) {
        lb = document.createElement('div');
        lb.className = 'dpg-lb';
        lb.hidden = true;
        lb.setAttribute('role', 'dialog');
        lb.setAttribute('aria-modal', 'true');
        lb.setAttribute('aria-label', name + ' images');
        document.body.appendChild(lb);
        lb.addEventListener('click', function (e) {
          if (e.target.closest('[data-x]')) return close();
          if (e.target.closest('[data-p]')) return go(cur - 1, true);
          if (e.target.closest('[data-n]')) return go(cur + 1, true);
          var t = e.target.closest('[data-t]');
          if (t) go(parseInt(t.getAttribute('data-t'), 10), true);
        });
      }
      var sl = '', th = '';
      list.forEach(function (it, i) {
        sl += '<li class="dpg-lb__slide"><img class="dpg-lb__img" src="' + esc(it.src) + '" alt="' + esc(it.alt) + '" loading="lazy"></li>';
        th += '<li><button type="button" class="dpg-lb__thumb" data-t="' + i + '" aria-label="Show image ' + (i + 1) + '"><img src="' + esc(it.th) + '" alt="" loading="lazy"></button></li>';
      });
      lb.innerHTML = '<button type="button" class="dpg-lb__close" data-x aria-label="Close"><svg aria-hidden="true" focusable="false" width="16" height="16" viewBox="0 0 16 16" fill="none"><path d="M2 2l12 12M14 2L2 14" stroke="currentColor" stroke-width="1.4"/></svg></button>' +
        '<ul class="dpg-lb__rail" role="list">' + th + '</ul><ul class="dpg-lb__track" role="list">' + sl + '</ul>' +
        '<button type="button" class="dpg-lb__arrow dpg-lb__arrow--prev" data-p aria-label="Previous image"><svg aria-hidden="true" focusable="false" width="12" height="20" viewBox="0 0 12 20" fill="none"><path d="M10 2L2 10l8 8" stroke="currentColor" stroke-width="1.5"/></svg></button>' +
        '<button type="button" class="dpg-lb__arrow dpg-lb__arrow--next" data-n aria-label="Next image"><svg aria-hidden="true" focusable="false" width="12" height="20" viewBox="0 0 12 20" fill="none"><path d="M2 2l8 8-8 8" stroke="currentColor" stroke-width="1.5"/></svg></button>';
      track = $('.dpg-lb__track', lb); rail = $('.dpg-lb__rail', lb); prevB = $('[data-p]', lb); nextB = $('[data-n]', lb);
      var tk = false;
      track.addEventListener('scroll', function () {
        if (tk) return; tk = true;
        requestAnimationFrame(function () { tk = false; var i = Math.round(track.scrollLeft / (track.clientWidth || 1)); if (i !== cur) state(i); });
      }, { passive: true });
    }
    function state(i) {
      cur = i;
      $$('[data-t]', lb).forEach(function (b, k) { if (k === i) b.setAttribute('aria-current', 'true'); else b.removeAttribute('aria-current'); });
      prevB.disabled = i <= 0; nextB.disabled = i >= list.length - 1;
    }
    function go(i, smooth) {
      if (i < 0 || i >= list.length) return;
      var s = $$('.dpg-lb__slide', lb);
      [s[i - 1], s[i], s[i + 1]].forEach(function (el) { var im = el && $('img', el); if (im) im.loading = 'eager'; });
      track.scrollTo({ left: s[i].offsetLeft, behavior: smooth && !window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'smooth' : 'auto' });
      state(i);
    }
    function onKey(e) {
      if (e.key === 'Escape') { e.preventDefault(); close(); }
      else if (e.key === 'ArrowRight') { e.preventDefault(); go(cur + 1, true); }
      else if (e.key === 'ArrowLeft') { e.preventDefault(); go(cur - 1, true); }
      else if (e.key === 'Tab') {
        var f = $$('button:not([disabled])', lb).filter(function (b) { return b.offsetParent !== null; });
        if (!f.length) return;
        if (e.shiftKey && document.activeElement === f[0]) { e.preventDefault(); f[f.length - 1].focus(); }
        else if (!e.shiftKey && document.activeElement === f[f.length - 1]) { e.preventDefault(); f[0].focus(); }
      }
    }
    function open(fig) {
      build();
      var i = shown().indexOf(fig);
      if (i < 0) return;
      lastFocus = document.activeElement;
      lb.hidden = false;
      prevOv = document.documentElement.style.overflow;
      document.documentElement.style.overflow = 'hidden';
      document.addEventListener('keydown', onKey);
      go(i, false);
      $('[data-x]', lb).focus({ preventScroll: true });
    }
    function close() {
      if (!lb || lb.hidden) return;
      lb.hidden = true;
      document.documentElement.style.overflow = prevOv || '';
      document.removeEventListener('keydown', onKey);
      if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
    }
    gal.addEventListener('click', function (e) {
      if (!DESK.matches) return;
      var f = e.target.closest('.dspp__f');
      if (f && gal.contains(f)) { e.preventDefault(); open(f); }
    });
    gal.addEventListener('keydown', function (e) {
      if (!DESK.matches || (e.key !== 'Enter' && e.key !== ' ')) return;
      var f = e.target.closest('.dspp__f[data-dspp-zoom]');
      if (f) { e.preventDefault(); open(f); }
    });
    function sync() {
      if (DESK.matches) mark();
      else $$('.dspp__f[data-dspp-zoom]', gal).forEach(function (f) { f.removeAttribute('data-dspp-zoom'); f.removeAttribute('tabindex'); f.removeAttribute('role'); f.removeAttribute('aria-label'); });
    }
    sync();
    if (DESK.addEventListener) DESK.addEventListener('change', sync); else if (DESK.addListener) DESK.addListener(sync);
  }

  function init() {
    var G = window.__dsp;
    var key = G && G.shown;
    var panel = key ? document.querySelector('[data-dsp-key="' + key + '"]') : $('.dsp__panel--pdp');
    if (!panel || key === '__none__' || !$('.dspp__buy', panel)) return;
    key = panel.getAttribute('data-dsp-key');
    var items = itemsOf(panel);
    try { frames(panel, items); } catch (e) {}
    try { fillRows(panel, items); } catch (e) {}
    try { fillCloser(items); } catch (e) {}
    try { fillReviews(items); } catch (e) {}
    try { fillMore(G, key, items); } catch (e) {}
    try { ld($('.dspp__buy', panel).getAttribute('data-name'), items); } catch (e) {}
    gallery(panel);
    try { viewer(panel); } catch (e) {}
    var x = $('[data-dspx]');
    if (x) x.hidden = false;
    if (G) G.panels = null; /* release the detached panels */
  }

  var G0 = window.__dsp;
  if (G0 && G0.ready) init();
  else if (G0) document.addEventListener('dsp:ready', init, { once: true });
  else if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
